import React from 'react';
import LongText from '../../Elements/LongText';
import FieldTypesEnum from '../../Enums/FieldTypesEnum';
import JsxHelper from '../../Helpers/JsxHelper';
import DataTableActionMenu from '../../Elements/DataTable/DataTableActionMenu';
import { isEntryLocked, mapBaseFields, initBaseFields } from './outsourcedUserFteHelpers';

export default class OutsourcedUserFteItem {
  constructor(item) {
    if (item === undefined) {
      initBaseFields(this);
      return;
    }

    mapBaseFields(this, item);
  }

  static displayedInList = 'FieldworkOfficeName';

  static NameOfTheIdField() {
    return 'OutsourcedUserFteid';
  }

  static MoneyFields = [];
  static Currency() {
    return '';
  }
  static MoneyFieldsSecondary = [];
  static CurrencySecondary() {
    return '';
  }
  static DateOnlyFields = [];
  static DateFields = [];
  static BoolFields = [];

  static nameOfTheItemDetailList(item) {
    if (item)
      return (
        <span>
          FTE Entry - <LongText text={`${item.FieldworkOfficeName} (${item.Ftepercentage}%)`} maxLength={40} />
        </span>
      );
    return 'FTE Entry Details';
  }

  static editFunction = (id, item, itemList) => {
    alert('Empty function');
  };

  static deleteFunction = (item) => {
    alert('Empty function');
  };

  static getActionsContent(item) {
    const locked = isEntryLocked(item);
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            onClick: () => OutsourcedUserFteItem.editFunction(item.OutsourcedUserFteid, item),
            roleKey: 'outsourcedfte_edit',
            disabled: locked,
          },
          {
            iconName: 'fa-regular fa-trash-can',
            text: 'Delete',
            onClick: () => OutsourcedUserFteItem.deleteFunction(item),
            roleKey: 'outsourcedfte_edit',
            disabled: locked,
          },
        ]}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Office',
        orderById: 'FieldworkOfficeName',
        data: 'FieldworkOfficeName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'FTE %',
        orderById: 'Ftepercentage',
        data: (item) => `${item.Ftepercentage}%`,
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Start Date',
        orderById: 'StartDateUtc',
        data: 'StartDateUtc',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'End Date',
        orderById: 'EndDateUtc',
        data: 'EndDateUtc',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Status',
        orderById: 'Status',
        data: 'Status',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: ' ',
        orderById: '',
        data: OutsourcedUserFteItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static FieldsToShowInListTable = [];
}
